import { Component, Input, OnInit } from '@angular/core';
import { UiService } from '../../../core/services/core.ui.service'
import { UserService } from '../../../core/services/core.user.service';
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { FeatureFlagService } from '../../../core/services/core.feature-flags.service';
import { ChatStatusService } from '../../../core/services/core.chat-status.service';

@Component({
    selector: 'account-widget',
    template: require('./account-widget.component.html')
})
export class AccountWidget implements OnInit {

    @Input() user: any = null;
    @Input() siteConfig: any = null;

    protected hasUser;

    constructor(
        private uiService: UiService, 
        protected userService: UserService, 
        private stateService: StateService, 
        private gfTranslateService: GfTranslateService,
        public featureFlagService: FeatureFlagService,
        public chatStatusService: ChatStatusService
    ) { }
    
    ngOnInit() {
        this.hasUser = this.userService.session.hasUser();
        if (this.hasUser) {
            this.chatStatusService.load();
        }
    }

    logout() {
        var logoutPromise = this.userService.session.logout();

        logoutPromise.then((response) => {
            if (response.success) {
                //PollService.reset();
                var msgTitle = this.gfTranslateService.translate('Logged out');
                var msgDescription = this.gfTranslateService.translate('You have been logged out of GForge');
                this.uiService.message.showSuccess(msgDescription, msgTitle);
            } else {
                var msgErrorTitle = this.gfTranslateService.translate('Logout error');
                var msgErrorDescription = this.gfTranslateService.translate('There was a problem trying to log you out of GForge');
                this.uiService.message.showError(msgErrorDescription, msgErrorTitle);
            }
        }).finally(() => { this.stateService.reload(); });
    };

    setFeatureLevel(name, level) {
        this.featureFlagService.setFeatureLevel(this.userService.getUnixName(), name, level);
    }
}